import './ready';

import './index.css';
import './footer';
